import React, { useEffect, useState } from "react";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import { getVerificationLogs } from "../services/Tools";

const VerificationList = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState("Success");
  const navigate = useNavigate();

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (userId) {
      fetchLogs(userId);
    }
  }, []);

  const fetchLogs = async (userId) => {
    setLoading(true);
    try {
      const res = await getVerificationLogs(userId);
      setData(res?.data || []);
    } catch (err) {
      message.error(
        err?.response?.data?.message || "Failed to load verification logs"
      );
    } finally {
      setLoading(false);
    }
  };

 const filteredData = data.filter((item) =>
    filter === "All"
      ? true
      : String(item.type || "").toLowerCase().includes(filter.toLowerCase())
  );

  const formatDate = (dateStr) => {
  if (!dateStr) return "-";

  const d = new Date(dateStr);

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  return `${day}/${month}/${year}`;
};

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: 30 }}>
        Loading...
      </div>
    );
  }

  return (
      <div
    style={{
      width: "90vw",
      overflowX: "auto",
      WebkitOverflowScrolling: "touch",
      position: "relative",
    }}
  >
    <div
      style={{
        width: "100%",
        overflowX: "auto",
        WebkitOverflowScrolling: "touch",
      }}
    >
      <div
        style={{
          marginBottom: 12,
          display: "flex",
          justifyContent: "flex-start",
        }}
      >
        <label
          style={{
            marginRight: 8,
            fontSize: 14,
            fontWeight: 600,
            color: "#333",
          }}
        >
          Type:
        </label>
        <select
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          style={{
            padding: "6px 12px",
            borderRadius: 4,
            border: "1px solid #d9d9d9",
            fontSize: 14,
          }}
        >
          <option value="All">All</option>
          <option value="Success">Success</option>
          <option value="Fail">Failure</option>
        </select>
      </div>
      <table
        style={{
          borderCollapse: "collapse",
          minWidth: "1100px",
          width: "1100px",
          background: "#fff",
        }}
      >
        <thead>
          <tr>
            {[
              "S.No",
              "Date",
              "Model Number",
              "Hologram Number",
              "Message",
              "Type",
              
              "Warranty",
              "Reward",
            ].map((item) => (
              <th
                key={item}
                style={{
                  background: "#1677ff",
                  color: "#fff",
                  border: "1px solid #ddd",
                  padding: "12px",
                  textAlign: "left",
                  whiteSpace: "nowrap",
                }}
              >
                {item}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {filteredData.length ? (
            filteredData.map((item, index) => (
              <tr key={item.id || index}>
                <td style={cell}>{index + 1}</td>

                <td style={cell}>{formatDate(item.date)}</td>

                <td style={cell}>{item.modelno}</td>

                <td style={cell}>{item.hologramno}</td>

                <td
                  style={{
                    ...cell,
                    width: 300,
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                  }}
                >
                  {item.msg}
                </td>

                <td style={cell}>
                  <span
                    style={{
                      background:
                        item.type === "Success"
                          ? "#52c41a"
                          : "#ff4d4f",
                      color: "#fff",
                      padding: "4px 10px",
                      borderRadius: 20,
                      fontSize: 12,
                    }}
                  >
                    {item.type}
                  </span>
                </td>

          

                <td style={cell}>
                  <button
                    disabled={item.iswarranty !== "0"}
                    onClick={() =>
                      navigate("/verificationSuccess", {
                        state: { verifiedProduct: item },
                      })
                    }
                    style={{
                      background:
                        item.iswarranty === "0"
                          ? "#1677ff"
                          : "#d9d9d9",
                      color: "#fff",
                      border: "none",
                      padding: "8px 16px",
                      borderRadius: 4,
                      cursor:
                        item.iswarranty === "0"
                          ? "pointer"
                          : "not-allowed",
                    }}
                  >
                    Register
                  </button>
                </td>
                      <td style={cell}>{item.reward}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={8}
                style={{
                  textAlign: "center",
                  padding: 20,
                  border: "1px solid #ddd",
                }}
              >
                No Data Found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
    </div>
  );
};

const cell = {
  border: "1px solid #ddd",
  padding: "10px",
  whiteSpace: "nowrap",
  verticalAlign: "top",
};

export default VerificationList;